<div class="win-cover">
</div>
<div class="win-bravo">
    <div #container class="bravo">
        <div id="win"></div>
    </div>
</div>
<div class="win-award">
    <div class="card-win">
        <div class="card-word-english">
            <h2>{{ wordEnglish ? wordEnglish : 'GOOD LUCK' }}</h2>
        </div>
        <div class="speech">
            <img src="../../../assets/images/main/sound_english.png"
                 (click)="speechClick(wordEnglish)" alt="" *ngIf="readingReady">
        </div>
        <div class="card-keo">
            <img class="animated tada count3 card-img" [src]="cardImgDirectory + cardrec?.path"
                 alt="">
        </div>
        <div class="card-footer">
            <img src="../../../assets/images/main/reset_button.png"
                 (click)="resetGame()" alt="" *ngIf="readingReady">
            <h2>{{ wordTranslate ? wordTranslate : wordEnglish }}</h2>
            <img src="../../../assets/images/main/back.png" class="rotateimg180"
                 (click)="goNextLevel()" alt="" *ngIf="readingReady">
        </div>
    </div>
</div>
